import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { keys } from "./constants";

export const useInvalidateHomeSummary = () => {
  const queryClient = useQueryClient();
  return useCallback(() => queryClient.invalidateQueries(keys.summary()), [queryClient]);
};
